/** 后台登录态（与前台 `token` 分离，避免互相覆盖） */
export const ADMIN_TOKEN_KEY = 'admin_token';
export const ADMIN_USER_EMAIL_KEY = 'admin_user_email';
export const ADMIN_USER_ID_KEY = 'admin_user_id';

export function clearAdminSession(): void {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(ADMIN_TOKEN_KEY);
  window.localStorage.removeItem(ADMIN_USER_EMAIL_KEY);
  window.localStorage.removeItem(ADMIN_USER_ID_KEY);
}

/** 是否在后台业务页（需 admin_token，不含登录页） */
export function isAdminProtectedPath(): boolean {
  if (typeof window === 'undefined') return false;
  const clean = window.location.pathname.split('?')[0].replace(/\/+$/, '') || '/';
  if (clean === '/admin/login') return false;
  return clean === '/admin' || clean.startsWith('/admin/');
}

/** 访问后台业务页（非登录页）时应携带的 Bearer token */
export function resolveApiBearerToken(): string | null {
  if (typeof window === 'undefined') return null;
  const path = window.location.pathname;
  const onAdminApp =
    path === '/admin' || (path.startsWith('/admin/') && !path.startsWith('/admin/login'));
  if (onAdminApp) {
    return window.localStorage.getItem(ADMIN_TOKEN_KEY);
  }
  return window.localStorage.getItem('token');
}

export function saveAdminSession(user: { id: number; email: string; token: string }): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(ADMIN_TOKEN_KEY, user.token);
  window.localStorage.setItem(ADMIN_USER_EMAIL_KEY, user.email);
  window.localStorage.setItem(ADMIN_USER_ID_KEY, String(user.id));
}
